<section>

  <div class="landing-page" style="background-color:black; color: white;">
    <div class="landing-page-section flex"
      style="width: 100%; min-height: 557px; padding: 0px; justify-content: center;">
      <div class="media"
        style="background-size: cover; background-repeat: no-repeat; background-position: center 0px; position: absolute; inset: 0px; overflow: hidden;">
        <video src="/assets/videos/WebClip.mp4" autoplay="" loop=""
          style="height: 100%; min-width: 100%; min-height: 56.25vw; position: absolute; right: 0px; bottom: 0px;"></video>
      </div>
      <div class="content" style="position: absolute; inset: 0px;">
        <div class="flex flex-center" style="height: 100%; background-color: rgba(0,0,0,0.9);">
          <h1 class="text-center">SPORTS TECH</h1>
          <div class="banner-description flex flex-center">
            <div>First class show management powered by cutting edge technology.</div>
            <div>Jumping, Dressage, Para-Dressage, Cross Country and Hunters.</div>
          </div>
          <!-- <button class="button-try-it-now">Try it Now</button> -->
          <img
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACkAAAApCAYAAACoYAD2AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAGnSURBVHgB7dXBbYMwFIDhB4fcgjICI2SEIuDALRuUTNB2giYTtBuETMCRAyBG6AjNCD1zgL4X0cqlODxjV+rBv1S1tSD+gmUMYLPZbDabbchRuTjP843neae2bZ+SJLmAYkVR+KvV6sV13X0QBB/c+1zuhQRcr9cN/rnDiRqaEBQagNf7+75vsA33XjYSn+CD4zjb4V9fBSoAr9cjctt13SMwU1ruqqoyhN4LQxdc+uDW0o+BA/IcRVEKf4FUhZoALkJyoaaAi5FzUJNALaQMihtij6+YkykgpYWkJqA/0gVS2khKBjUBpNjvyVsRhEDimAxIhwIopoSkDVHX9TueFr+emgiVAek+PBTeVE8r9nKPdyxujhTP3/P4OvwSaRiGGUwAcVN9jc8eAmLsJ4nAHQg7liaceqIMIOUPn8eKjcTJX3Giozgmg84A6b4jfR4wU97dZVkecKmfxTHZ0suAcRwfQKFFryAO1BRwMRJmoCaBWkhqCopl+JOKAzpASvvEkUC/0wVSRo5FGdQEkDKCpMZQU0DjERRPnJ5+w38OgXdgs9lsrD4B4s9E3wTn7h4AAAAASUVORK5CYII="
            srcset="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACkAAAApCAYAAACoYAD2AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAGnSURBVHgB7dXBbYMwFIDhB4fcgjICI2SEIuDALRuUTNB2giYTtBuETMCRAyBG6AjNCD1zgL4X0cqlODxjV+rBv1S1tSD+gmUMYLPZbDabbchRuTjP843neae2bZ+SJLmAYkVR+KvV6sV13X0QBB/c+1zuhQRcr9cN/rnDiRqaEBQagNf7+75vsA33XjYSn+CD4zjb4V9fBSoAr9cjctt13SMwU1ruqqoyhN4LQxdc+uDW0o+BA/IcRVEKf4FUhZoALkJyoaaAi5FzUJNALaQMihtij6+YkykgpYWkJqA/0gVS2khKBjUBpNjvyVsRhEDimAxIhwIopoSkDVHX9TueFr+emgiVAek+PBTeVE8r9nKPdyxujhTP3/P4OvwSaRiGGUwAcVN9jc8eAmLsJ4nAHQg7liaceqIMIOUPn8eKjcTJX3Giozgmg84A6b4jfR4wU97dZVkecKmfxTHZ0suAcRwfQKFFryAO1BRwMRJmoCaBWkhqCopl+JOKAzpASvvEkUC/0wVSRo5FGdQEkDKCpMZQU0DjERRPnJ5+w38OgXdgs9lsrD4B4s9E3wTn7h4AAAAASUVORK5CYII=, data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFIAAABSCAYAAADHLIObAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAKvSURBVHgB7dpRitpAHMfxfxXEJ+kRPEKPUBEFH3uD7Q16A7Mn6BG2N/BRUCS9QXuEHKHPgtL5FQfyYJOZZP4z/4XfBxZdiTh+NyabGUWIiIiIiIiIiIiIiIiIiLI6Ho/Ly+Wyl0Lquv6OMYiyiSjCG5jNZrW7W7mYb5KZi/h2v9+/YQzaMT+IklbEZevhH+v1+qtk8Ij40nqouV6vq91u14gClZD/ieipx3wS0VOLmTxkT0RPLWZHRE8lZvJj5Hw+D9nsReOYGRDxn8AxRlH5aLs3tHRvqG+vhGR7ZmDEZjKZrJxGElM72eSMWToiqIWEHDEtRATVkKAZ00pEUA8JGjEtRYQsISFlTGsRIVtISBHTYkTIGhLGxLQaEbKHhCExLUeEIiEhJqaLI5YjQrGQEBGzT9GIUDQkJIhZPCIUDwkjYpqICCZCwoCYZiKCmZAQEdNURFBds/EOh8PHkO0QBoHc3aZjs6iIoa89lnpIt5ftF4vFr9DFp56YURHxmnhtjEGUaU+j7d1HtXr8GjXF/+RjHh2xveThnlu5576KEs2J3XZEb2hMGRPR04yptdTwLKIXHRO3YyN6WjGThzyfz5/dYOuezVRW8gJXMHG5udpsNj8loeQnGwzQDbTvL75M/e2HiIivqSOC2jHS7ZmV2zP7zpbN7Xb7st1uf8sIp9Pp03Q6RcTOf3UeEStRoHrWDoz5x8VcDY1pISKoX9loxrQSEbJcImrEtBQRsl1rp4xpLSJknbRIEdNiRMg++zMmptWIUGQabUhMyxGh2HxkTEzcsRwRik7shsZ83JqNCMVnyANjdiodEUwsNYyJaSEimFmzGRLTSkQwtfgVE9NSRDAVEkJiWosI5kJCV0yLEcFkSHgW02pEMBsS2jEtR3wXEBM/QkRERERERERE8f4CVYaR+TSmRP0AAAAASUVORK5CYII= 2x, data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHsAAAB7CAYAAABUx/9/AAAACXBIWXMAACE4AAAhOAFFljFgAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAN1SURBVHgB7dtBTttAFIfxaZBYIo5Ab9DeoFmwYJkTlJ6k9CSFE2SJBEI+QnuD5giskUjrf8VIqKIQx2PPe2++nxTFioQ0eR+G2LFTAgAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA9nVd91mP5JDltb9LxmhQ2+32UtuLxeJ8uVxeJSesr91U7OfDyrwE97B2M7FfGlZmPbiXtZuI/dqwMqvBPa29euxdhpVZC+5t7VVjDxlWZiW4x7VXi71er4+Pjo5+9ZvHaaDaQ9sn9JP7fu3v+7XfpwoWqZLVanX/+Pi47DcHv3ENutax7MjQy1qhpfr/7Jubmw8HBwddcrCHFwj9M1Vk4tO4h+DeQ4uZ42zLwSOEFlNn0CwGjxJazJ0btxQ8UmgxF1ssBI8WWkzGlprBI4YWs7GlRvCoocV0bJkzeOTQYj62zBE8emhxEVumDN5CaHETW6YI3kpocRVbSgZvKbS4iy0lgrcWWlzGljHBe5f94zwN5za0uI0tI4MP5Tq0uI4tMwV3H1rcx5aJg4cILSFiy0TBw4SWMLGlcPBQoSVUbCkUPFxoCRdbRgYPGVpCxpY9g4cNLSZjX19fn+j57Oxsk0YYGLxI6FJrn4K52BrW4eGhAqWHh4flTMGLhS659tJMxX42rJOnlzYzBC8d+uTppY214GZivzCsbMrgU4XOTAU3EfuVYWVTBJ86dGYmePXYOwwrKxl83YdezRA6MxG8auwBw8rM7CUe114tdtd1x9vt9kfafVhZ9aHtETrb9H9RPjZ3f7becB97nwv5/w46H8/ObURo3Vd+tWz5/uzb29uL/rf9axpu9j18ZOhvp6enF6kiE5/GPQT3HlrMHGdbDh4htJg6g2YxeJTQYu7cuKXgkUKLyW+9LASPFlrMfp9dM3jE0GL64oUawaOGFvNXqswZPHJoMR9b5ggePbS4iC1TBm8htLiJLVMEbyW0uIotJYO3FFrcxZYSwVsLLS5jy5jgfawv/c9+Tw2FFrexZUTwvXgOLa5jy1zBvYcW97Fl6uARQkuI2DJV8CihJUxsKR08UmgJFVtKBY8WWsLFlrHBI4aWkLFl3+BRQ0vY2DI0eOTQEjq27Bo8emgJH1veCt5CaGkitvwveCuhpZnY8m/wlkI3ScHv7u5+6zkhvj70pwQAAAAAAAAAAAAAAAAAGOsPKSivVgDM7isAAAAASUVORK5CYII= 3x"
            alt="" class="scroll-indicator">
        </div>
      </div>
    </div>

    <div class="landing-page-section flex" style="width: 100%; padding: 100px 0px; justify-content: center;">
      <div class="flex flex-center landing-page-features ">
        <h1>ALL-IN-ONE
          EQUESTRIAN PLATFORM</h1>
        <div class="flex horizontal features">
          <a class="feature-item flex "
            style="background-image: url(&quot;/assets/images/office.png&quot;); background-position: center center; background-size: cover;">
            <div class="mask flex"><img src="/assets/images/deskOffice.png" class="feature-icon" alt="">
              <h4>Office system</h4>
              <p>Organize your show using the most convenient tools.</p>
              <p>CSI5* shows or small local shows, ED has got you covered. </p>
              <div class="flex expand"></div>
              <!-- <div class="button-learn-more">Learn More</div> -->
            </div>
          </a>
          <a class="feature-item flex "
            style="background-image: url(&quot;/assets/images/app.png&quot;); background-position: center center; background-size: cover;">
            <div class="mask flex"><img src="/assets/images/appIcon.png" class="feature-icon" alt="">
              <h4>App & WebSite</h4>
              <p>See orders of go, results and video clips in real-time.</p>
              <div class="flex expand"></div>
              <!-- <div class="button-learn-more">Learn More</div> -->
            </div>
          </a>
          <a class="feature-item flex "
            style="background-image: url(&quot;/assets/images/video.png&quot;); background-position: center center; background-size: cover;">
            <div class="mask flex"><img src="/assets/images/cameraIcon.png" class="feature-icon" alt="">
              <h4>Video Production</h4>
              <p>Single or multi-camera.</p>
              <p>Video feeds for livestream, videoboards, TVs and other displays.</p>
              <div class="flex expand"></div>
              <!-- <div class="button-learn-more">Learn More</div> -->
            </div>
          </a>
          <!-- <a href="/main/products/analysis-software#contents" class="feature-item flex "
            style="background-image: url(&quot;/static/media/img-analysis-software@2x.e383631c.png&quot;); background-position: center center; background-size: cover;">
            <div class="mask flex"><img src="/static/media/icon-analysis-software@2x.f9c76701.png" class="feature-icon"
                alt="">
              <h4>Analysis Software</h4>
              <p>User-friendly platform to engage
                with players and coaching staff</p>
              <div class="flex expand"></div>
              <div class="button-learn-more">Learn More</div>
            </div>
          </a> -->
        </div>
      </div>
    </div>

    <!--
    <div class="landing-page-section flex" style="width: 100%; padding: 100px 0px; justify-content: center;">
      <div class="flex flex-center customer-quotes">
        <h3>WHAT OUR CUSTOMERS SAY</h3>
        <div class="flex horizontal" style="width: 100%;">
          <div class="quotes">
            <div class="quotes-inner flex horizontal" style="padding-left: 1280px; transform: translateX(-2231.4px);">
              <div class="quote-item flex" style="width: 240px; margin: 0px 40px;">
                <div class="profile-image-wrapper">
                  <div class="profile-image"
                    style="background-image: url(&quot;/static/media/quote-user-5.616caf6e.png&quot;);"></div>
                  <div class="club-image"
                    style="background-image: url(&quot;/static/media/quote-club-5.d92f71ca.png&quot;);"></div>
                </div><img class="quote-mark" src="/static/media/icon-quote-marks@2x.217c91a4.png">
                <div class="user-name">Jasper Hölscher</div>
                <p>Sports Coordinator &amp; U17s Head Coach of Eimsbütteler TV, Germany</p>
                <div class="message">“By working with Bepro, we have been able to take our team development to the
                  next
                  level."</div>
              </div>
              <div class="quote-item flex" style="width: 240px; margin: 0px 40px;">
                <div class="profile-image-wrapper">
                  <div class="profile-image"
                    style="background-image: url(&quot;/static/media/quote-user-1.0a8224c6.png&quot;);"></div>
                  <div class="club-image"
                    style="background-image: url(&quot;/static/media/quote-club-1.629a90f2.png&quot;);"></div>
                </div><img class="quote-mark" src="/static/media/icon-quote-marks@2x.217c91a4.png">
                <div class="user-name">Eduardo Rivacoba</div>
                <p>President of Club Portugalete, Spain</p>
                <div class="message">“Their platform made it easy for me and our coaching staff to use video and
                  data to
                  understand and improve performances."</div>
              </div>
              <div class="quote-item flex" style="width: 240px; margin: 0px 40px;">
                <div class="profile-image-wrapper">
                  <div class="profile-image"
                    style="background-image: url(&quot;/static/media/quote-user-2.3780df13.png&quot;);"></div>
                  <div class="club-image"
                    style="background-image: url(&quot;/static/media/quote-club-2.66f331af.png&quot;);"></div>
                </div><img class="quote-mark" src="/static/media/icon-quote-marks@2x.217c91a4.png">
                <div class="user-name">Takeshi Okada</div>
                <p>President of FC Imabari,
                  Japan</p>
                <div class="message">"I believe in the importance of performance data and video in modern
                  football.
                  Bepro’s platform includes everything we needed and more."</div>
              </div>
              <div class="quote-item flex" style="width: 240px; margin: 0px 40px;">
                <div class="profile-image-wrapper">
                  <div class="profile-image"
                    style="background-image: url(&quot;/static/media/quote-user-3.3bcd22ce.png&quot;);"></div>
                  <div class="club-image"
                    style="background-image: url(&quot;/static/media/quote-club-3.006be9ec.png&quot;);"></div>
                </div><img class="quote-mark" src="/static/media/icon-quote-marks@2x.217c91a4.png">
                <div class="user-name">Andrea Sentimenti</div>
                <p>Goalkeeping Coach, Bologna F.C. 1909, Italy</p>
                <div class="message">"The AI software provided by Bepro works really well, I can save a lot of
                  time and it
                  allows me to focus on other aspects of the analysis."</div>
              </div>
              <div class="quote-item flex" style="width: 240px; margin: 0px 40px;">
                <div class="profile-image-wrapper">
                  <div class="profile-image"
                    style="background-image: url(&quot;/static/media/quote-user-4.9514ec99.png&quot;);"></div>
                  <div class="club-image"
                    style="background-image: url(&quot;/static/media/quote-club-4.ced8e885.png&quot;);"></div>
                </div><img class="quote-mark" src="/static/media/icon-quote-marks@2x.217c91a4.png">
                <div class="user-name">Toni Ordinas</div>
                <p>Academy Director of Lillestrøm SK, Norway</p>
                <div class="message">"During more than 20 years I had the feeling that I watched but didn’t
                  analyse the
                  match. With Bepro this changed."</div>
              </div>
              <div class="quote-item flex" style="width: 240px; margin: 0px 40px;">
                <div class="profile-image-wrapper">
                  <div class="profile-image"
                    style="background-image: url(&quot;/static/media/quote-user-5.616caf6e.png&quot;);"></div>
                  <div class="club-image"
                    style="background-image: url(&quot;/static/media/quote-club-5.d92f71ca.png&quot;);"></div>
                </div><img class="quote-mark" src="/static/media/icon-quote-marks@2x.217c91a4.png">
                <div class="user-name">Jasper Hölscher</div>
                <p>Sports Coordinator &amp; U17s Head Coach of Eimsbütteler TV, Germany</p>
                <div class="message">“By working with Bepro, we have been able to take our team development to the
                  next
                  level."</div>
              </div>
            </div>
            <div class="fade fade-left"></div>
            <div class="fade fade-right"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="landing-page-section flex"
      style="width: 100%; padding: 100px 0px; justify-content: center; background-color: rgb(27, 27, 27);">
      <div class="flex flex-center updates-section">
        <h3>BEPRO TECHNOLOGY</h3>
        <div class="updates" style="max-height: 800px; overflow: hidden; position: relative;">
          <div class="update-item flex"><iframe width="511" height="275" src="https://www.youtube.com/embed/oOvdqiFvhtE"
              frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen=""></iframe>
            <div class="update-title-bar">Bepro11 Live Analysis - Realtime Match Analysis</div>
            <div class="flex expand update-content">
              <div class="update-description">Bepro Live Analysis sends match data to the Bepro11 platform in near
                realtime.</div>
            </div>
          </div>
          <div class="update-item flex"><iframe width="511" height="275" src="https://www.youtube.com/embed/mjFKFcqKH44"
              frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen=""></iframe>
            <div class="update-title-bar">New Interactive Video Features Powered
              by Tracking Data</div>
            <div class="flex expand update-content">
              <div class="update-description">Our tracking data allows you to better understand formations, team
                structure
                and player relationships through highly visual, interactive video.</div>
            </div>
          </div>
          <div class="update-item flex"><iframe width="511" height="275" src="https://www.youtube.com/embed/sYGtji8aDak"
              frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen=""></iframe>
            <div class="update-title-bar">Bepro Presents A Behind the Scenes Look at Suwon FC</div>
            <div class="flex expand update-content">
              <div class="update-description">Look at how leading K League 2 club Suwon FC use Bepro to measure,
                understand and improve performances. </div>
            </div>
          </div>
          <div class="update-item flex"><iframe width="511" height="275" src="https://www.youtube.com/embed/7lD4brh99i4"
              frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen=""></iframe>
            <div class="update-title-bar">Bepro11's Live Coding - Real Time Football Analysis</div>
            <div class="flex expand update-content">
              <div class="update-description">Live coding provides analysts and coaches with detailed data from
                key
                moments, in near real time.</div>
            </div>
          </div>
          <div class="update-item flex"><iframe width="511" height="275" src="https://www.youtube.com/embed/GVt1rZZOKzc"
              frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen=""></iframe>
            <div class="update-title-bar">Bepro11's Football Analysis Process</div>
            <div class="flex expand update-content">
              <div class="update-description">The best analysis processes and skilled analysts provide the teams
                with the
                most accurate and high-quality analysis.</div>
            </div>
          </div>
          <div class="update-item flex"><iframe width="511" height="275" src="https://www.youtube.com/embed/oMjRwINyznQ"
              frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen=""></iframe>
            <div class="update-title-bar">Bepro11's State of the Art Video Technology for Football Analysis</div>
            <div class="flex expand update-content">
              <div class="update-description">Our bespoke 4K camera technology stitches together three feeds to
                create
                high quality, interactive, panoramic video that allows you to see everything that happens on the
                pitch.
              </div>
            </div>
          </div>
          <div class="show-more-wrapper flex flex-center"><button>Show More</button></div>
        </div>
      </div>
    </div>
    <div class="landing-page-newsletter flex">
      <div class="banner flex flex-center"
        style="background-image: url(&quot;/static/media/img-timeto-level-up@2x.7ecb7a24.png&quot;);">
        <h3>IT'S TIME TO LEVEL UP</h3><a href="/main/contacts#get-in-touch" target="" rel="noreferrer">GET IN
          TOUCH</a>
      </div>
      <div class="newsletter-sign-up flex flex-center">
        <h4>UNMISSABLE INDUSTRY INSIGHTS</h4>
        <div class="description">Sign up to our newsletter to receive news and updates from Bepro</div>
        <form class="flex horizontal newsletter-form"><input type="email" class="" placeholder="example@bepro11.com"
            value=""><input type="hidden" value="MX"><button type="submit">Sign
            up</button></form>
        <div class="flex horizontal landing-page-checkbox ">
          <div class="checkbox flex flex-center "><i class="icon bepro-check-thick"></i></div><span
            class="checkbox-description">By ticking this box, you consent to receiving marketing emails from
            Bepro. You
            can update your preferences via our Email Subscription Centre. See our Privacy Policy below for
            further
            details.</span>
        </div>
      </div>
    </div>
    <div class="landing-page-footer flex">
      <div class="footer-content flex horizontal">
        <div class="logo-area flex"><img src="/static/media/bepro-logo-horizontal.e94d10a3.png" alt="" class="logo">
          <div class="copyright">© Bepro Company</div><a href="http://terms-of-use.bepro11.com/en-MX" target="_blank"
            rel="noreferrer">Terms of Use</a><a href="http://privacy-policy.bepro11.com/en-MX" target="_blank"
            rel="noreferrer">Privacy Policy</a>
        </div>
        <div class="social-icons flex horizontal"><a href="https://www.linkedin.com/company/bepro-company"
            rel="noreferrer" target="_blank"><i class="icon bepro-linkedin-fill"></i></a><a
            href="https://twitter.com/Bepro_EN" rel="noreferrer" target="_blank"><i
              class="icon bepro-twitter-fill"></i></a><a href="https://www.facebook.com/bepro11" rel="noreferrer"
            target="_blank"><i class="icon bepro-facebook-rounded-rect-fill"></i></a><a
            href="https://www.instagram.com/bepro_eleven/" rel="noreferrer" target="_blank"><i
              class="icon bepro-instagram-fill"></i></a><a
            href="https://www.youtube.com/channel/UCUKv438My58DvjhzRqNuCfw" rel="noreferrer" target="_blank"><i
              class="icon bepro-youtube-fill"></i></a></div>
        <div class="flex horizontal footer-navigation">
          <div class="menu"><a href="/main" class="category">Home </a></div>
          <div class="menu"><a href="/main/products" class="category">Products</a></div>
          <div class="menu"><a href="/main/company" class="category">Company</a></div>
          <div class="menu"><a href="/main/contacts" class="category">Contact</a></div>
        </div>
      </div>
    </div> -->
  </div>

</section>
<!--
<section class="py-4">
  <div class="container">
    <div class="row">
      <div class="col-lg-12">
        <h1>TECHNOLOGY FOR EQUESTRIAN EVENTS</h1>
        <p>All-in-one show management platform powered by cutting edge technology. </p>
        <p>This policy is effective as of 16 October 2021 and was last updated on 16 October 2021. </p>
        <h3>Information We Collect</h3>
        <p>Information we collect includes both information you knowingly and actively provide us when using or
          participating in any of our services and promotions, and any information automatically sent by your devices in
          the course of accessing our products and services. </p>
        <h4>Log Data</h4>
        <p>When you visit our website, our servers may automatically log the standard data provided by your web browser.
          It may include your device’s Internet Protocol (IP) address, your browser type and version, the pages you
          visit, the time and date of your visit, the time spent on each page, other details about your visit, and
          technical details that occur in conjunction with any errors you may encounter. </p>
        <p>Please be aware that while this information may not be personally identifying by itself, it may be possible
          to combine it with other data to personally identify individual persons. </p>
        <h4>Collection and Use of Information</h4>
        <p>We may collect personal information from you when you do any of the following on our website: </p>
        <ul>
          <li>Use a mobile device or web browser to access our content</li>
          <li>Contact us via email, social media, or on any similar technologies</li>
          <li>When you mention us on social media</li>
        </ul>
        <p>We may collect, hold, use, and disclose information for the following purposes, and personal information will
          not be further processed in a manner that is incompatible with these purposes: </p>
        <p>Please be aware that we may combine information we collect about you with general information or research
          data we receive from other trusted sources. </p>
        <h4>Security of Your Personal Information</h4>
        <p>When we collect and process personal information, and while we retain this information, we will protect it
          within commercially acceptable means to prevent loss and theft, as well as unauthorized access, disclosure,
          copying, use, or modification. </p>
        <p>Although we will do our best to protect the personal information you provide to us, we advise that no method
          of electronic transmission or storage is 100% secure, and no one can guarantee absolute data security. We will
          comply with laws applicable to us in respect of any data breach. </p>
        <p>You are responsible for selecting any password and its overall security strength, ensuring the security of
          your own information within the bounds of our services. </p>
        <h4>How Long We Keep Your Personal Information</h4>
        <p>We keep your personal information only for as long as we need to. This time period may depend on what we are
          using your information for, in accordance with this privacy policy. If your personal information is no longer
          required, we will delete it or make it anonymous by removing all details that identify you. </p>
        <p>However, if necessary, we may retain your personal information for our compliance with a legal, accounting,
          or reporting obligation or for archiving purposes in the public interest, scientific, or historical research
          purposes or statistical purposes. </p>
        <h3>Children’s Privacy</h3>
        <p>We do not aim any of our products or services directly at children under the age of 13, and we do not
          knowingly collect personal information about children under 13. </p>
        <h3>Disclosure of Personal Information to Third Parties</h3>
        <p>We may disclose personal information to: </p>
        <ul>
          <li>a parent, subsidiary, or affiliate of our company</li>
          <li>third party service providers for the purpose of enabling them to provide their services, for example, IT
            service providers, data storage, hosting and server providers, advertisers, or analytics platforms</li>
          <li>our employees, contractors, and/or related entities</li>
          <li>our existing or potential agents or business partners</li>
          <li>sponsors or promoters of any competition, sweepstakes, or promotion we run</li>
          <li>courts, tribunals, regulatory authorities, and law enforcement officers, as required by law, in connection
            with any actual or prospective legal proceedings, or in order to establish, exercise, or defend our legal
            rights</li>
          <li>third parties, including agents or sub-contractors, who assist us in providing information, products,
            services, or direct marketing to you third parties to collect and process data</li>
        </ul>
        <h3>International Transfers of Personal Information</h3>
        <p>The personal information we collect is stored and/or processed where we or our partners, affiliates, and
          third-party providers maintain facilities. Please be aware that the locations to which we store, process, or
          transfer your personal information may not have the same data protection laws as the country in which you
          initially provided the information. If we transfer your personal information to third parties in other
          countries: (i) we will perform those transfers in accordance with the requirements of applicable law; and (ii)
          we will protect the transferred personal information in accordance with this privacy policy. </p>
        <h3>Your Rights and Controlling Your Personal Information</h3>
        <p>You always retain the right to withhold personal information from us, with the understanding that your
          experience of our website may be affected. We will not discriminate against you for exercising any of your
          rights over your personal information. If you do provide us with personal information you understand that we
          will collect, hold, use and disclose it in accordance with this privacy policy. You retain the right to
          request details of any personal information we hold about you. </p>
        <p>If we receive personal information about you from a third party, we will protect it as set out in this
          privacy policy. If you are a third party providing personal information about somebody else, you represent and
          warrant that you have such person’s consent to provide the personal information to us. </p>
        <p>If you have previously agreed to us using your personal information for direct marketing purposes, you may
          change your mind at any time. We will provide you with the ability to unsubscribe from our email-database or
          opt out of communications. Please be aware we may need to request specific information from you to help us
          confirm your identity. </p>
        <p>If you believe that any information we hold about you is inaccurate, out of date, incomplete, irrelevant, or
          misleading, please contact us using the details provided in this privacy policy. We will take reasonable steps
          to correct any information found to be inaccurate, incomplete, misleading, or out of date. </p>
        <p>If you believe that we have breached a relevant data protection law and wish to make a complaint, please
          contact us using the details below and provide us with full details of the alleged breach. We will promptly
          investigate your complaint and respond to you, in writing, setting out the outcome of our investigation and
          the steps we will take to deal with your complaint. You also have the right to contact a regulatory body or
          data protection authority in relation to your complaint. </p>
        <h3>Limits of Our Policy</h3>
        <p>Our website may link to external sites that are not operated by us. Please be aware that we have no control
          over the content and policies of those sites, and cannot accept responsibility or liability for their
          respective privacy practices. </p>
        <h3>Changes to This Policy</h3>
        <p>At our discretion, we may change our privacy policy to reflect updates to our business processes, current
          acceptable practices, or legislative or regulatory changes. If we decide to change this privacy policy, we
          will post the changes here at the same link by which you are accessing this privacy policy. </p>
        <p>If required by law, we will get your permission or give you the opportunity to opt in to or opt out of, as
          applicable, any new uses of your personal information. </p>
        <h3>Contact Us</h3>
        <p>For any questions or concerns regarding your privacy, you may contact us using the following details: </p>
        <p>Equestrian Digital<br />
          hi@equestrian.digital </p>

      </div>
    </div>
  </div>
</section>

<h1>
  EQUESTRIAN DIGITAL
</h1>
<h2>
  TECHNOLOGY FOR EQUESTRIAN EVENTS
</h2>
<h3>In a connected age, it’s time to bring technology into a traditional sport.</h3>

<h2>ENTERTAINMENT</h2>

<b>SHOWS ARE MEANT TO BE FUN FOR EVERYONE</b>
Bring your show to every rider’s home
<div dir="ltr">

  CERTIFICATIONS
  <p
    style="margin:0px;font-variant-numeric:normal;font-variant-east-asian:normal;font-stretch:normal;font-size:13px;line-height:normal;font-family:&quot;Helvetica Neue&quot;;min-height:15px">
    <br>
  </p>
  <p
    style="margin:0px;font-variant-numeric:normal;font-variant-east-asian:normal;font-stretch:normal;font-size:13px;line-height:normal;font-family:&quot;Helvetica Neue&quot;;min-height:15px">
    <br>
  </p>
  <p
    style="margin:0px;font-variant-numeric:normal;font-variant-east-asian:normal;font-stretch:normal;font-size:13px;line-height:normal;font-family:&quot;Helvetica Neue&quot;">
    <b><span>&nbsp;</span>FEI</b>
  </p>
  <p
    style="margin:0px;text-align:center;font-variant-numeric:normal;font-variant-east-asian:normal;font-stretch:normal;font-size:13px;line-height:normal;font-family:&quot;Helvetica Neue&quot;">
    Athlete information</p>
  <p
    style="margin:0px;text-align:center;font-variant-numeric:normal;font-variant-east-asian:normal;font-stretch:normal;font-size:13px;line-height:normal;font-family:&quot;Helvetica Neue&quot;">
    Horse Information</p>
  <p
    style="margin:0px;text-align:center;font-variant-numeric:normal;font-variant-east-asian:normal;font-stretch:normal;font-size:13px;line-height:normal;font-family:&quot;Helvetica Neue&quot;">
    Master List confirmation</p>
  <p
    style="margin:0px;text-align:center;font-variant-numeric:normal;font-variant-east-asian:normal;font-stretch:normal;font-size:13px;line-height:normal;font-family:&quot;Helvetica Neue&quot;">
    Results uploading</p>

  <p
    style="margin:0px;font-variant-numeric:normal;font-variant-east-asian:normal;font-stretch:normal;font-size:13px;line-height:normal;font-family:&quot;Helvetica Neue&quot;">
    <b>USEF</b>
  </p>

  <p
    style="margin:0px;text-align:center;font-variant-numeric:normal;font-variant-east-asian:normal;font-stretch:normal;font-size:13px;line-height:normal;font-family:&quot;Helvetica Neue&quot;">
    Athlete Information</p>
  <p
    style="margin:0px;text-align:center;font-variant-numeric:normal;font-variant-east-asian:normal;font-stretch:normal;font-size:13px;line-height:normal;font-family:&quot;Helvetica Neue&quot;">
    Horse Information</p>
  <p
    style="margin:0px;text-align:center;font-variant-numeric:normal;font-variant-east-asian:normal;font-stretch:normal;font-size:13px;line-height:normal;font-family:&quot;Helvetica Neue&quot;">
    Suspensions</p> -->
